import { useState } from "react";

const frequenzeManutenzione = [
  { label: "Mensile", value: 1 },
  { label: "Trimestrale", value: 3 },
  { label: "Semestrale", value: 6 },
  { label: "Annuale", value: 12 },
  { label: "Biennale", value: 24 },
  { label: "Personalizzata", value: "custom" },
];

function MaintenancePanel({
  cardStyle,
  emptyBoxStyle,
  inputStyle,
  sectionTitleStyle,
  primaryButtonStyle,
  manutenzioni,
  mostraNuovaManutenzione,
  nuovaManutenzione,
  setMostraNuovaManutenzione,
  setNuovaManutenzione,
  salvaNuovaManutenzione,
  completaManutenzione,
  eliminaManutenzione,
  modificaManutenzione,
  formatDate,
  getStatusBadge,
  renderActions,
}) {

  const utenteCorrente = JSON.parse(
  localStorage.getItem("utenteCorrente")
);

  const labelStyle = {
    fontSize: "13px",
    fontWeight: 700,
    marginBottom: "6px",
    color: "#475569",
  };

  const helpTextStyle = {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "5px",
    lineHeight: "1.4",
  };

  const fieldWrapperStyle = {
    display: "flex",
    flexDirection: "column",
  };

  const [manutenzioneInModificaId, setManutenzioneInModificaId] = useState(null);
const [manutenzioneModificata, setManutenzioneModificata] = useState({
  title: "",
  frequency_months: "",
  next_due_date: "",
  status: "Programmato",
  notes: "",
});

  const getFrequenzaLabel = (mesi) => {
    const numeroMesi = Number(mesi);

    if (numeroMesi === 1) return "Mensile";
    if (numeroMesi === 3) return "Trimestrale";
    if (numeroMesi === 6) return "Semestrale";
    if (numeroMesi === 12) return "Annuale";
    if (numeroMesi === 24) return "Biennale";

    return `Personalizzata: ogni ${numeroMesi || "—"} mesi`;
  };

  const frequenzaSelezionata = frequenzeManutenzione.some(
    (frequenza) => frequenza.value === Number(nuovaManutenzione.frequency_months)
  )
    ? Number(nuovaManutenzione.frequency_months)
    : "custom";

  const handleCompletaManutenzione = (id) => {
    if (typeof completaManutenzione !== "function") {
      alert(
        "Funzione completamento manutenzione non ancora collegata al componente padre."
      );
      return;
    }

    completaManutenzione(id);
  };

  const handleEliminaManutenzione = (id) => {
  if (typeof eliminaManutenzione !== "function") {
    alert("Funzione eliminazione manutenzione non disponibile.");
    return;
  }

  eliminaManutenzione(id);
};

  return (
    <div style={cardStyle}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "14px",
        }}
      >
        <h2 style={sectionTitleStyle}>
  Manutenzioni ({manutenzioni.length})
</h2>

        {utenteCorrente?.role !== "viewer" && (
  <button
    className="btn btn-primary"
    onClick={() => setMostraNuovaManutenzione(true)}
    style={primaryButtonStyle}
  >
    + Manutenzione
  </button>
)}
      </div>

      {mostraNuovaManutenzione && (
        <div
          style={{
            ...emptyBoxStyle,
            marginBottom: "18px",
            display: "flex",
            flexDirection: "column",
            gap: "14px",
          }}
        >
          <div style={fieldWrapperStyle}>
            <div style={labelStyle}>Nome manutenzione</div>
            <input
              placeholder="Esempio: Manutenzione annuale caldaia"
              value={nuovaManutenzione.title}
              onChange={(e) =>
                setNuovaManutenzione({
                  ...nuovaManutenzione,
                  title: e.target.value,
                })
              }
              style={inputStyle}
            />
            <div style={helpTextStyle}>
              Inserisci una descrizione chiara dell’attività da programmare.
            </div>
          </div>

          <div style={fieldWrapperStyle}>
            <div style={labelStyle}>Frequenza manutenzione</div>
            <select
              value={frequenzaSelezionata}
              onChange={(e) => {
                const value = e.target.value;

                setNuovaManutenzione({
                  ...nuovaManutenzione,
                  frequency_months: value === "custom" ? "" : Number(value),
                });
              }}
              style={inputStyle}
            >
              <option value="">Seleziona frequenza manutenzione</option>

              {frequenzeManutenzione.map((frequenza) => (
                <option key={frequenza.value} value={frequenza.value}>
                  {frequenza.label}
                </option>
              ))}
            </select>
            <div style={helpTextStyle}>
              Indica ogni quanto tempo questa manutenzione deve essere ripetuta.
            </div>
          </div>

          {frequenzaSelezionata === "custom" && (
            <div style={fieldWrapperStyle}>
              <div style={labelStyle}>Frequenza personalizzata</div>
              <input
                type="number"
                min="1"
                placeholder="Esempio: 18"
                value={nuovaManutenzione.frequency_months}
                onChange={(e) =>
                  setNuovaManutenzione({
                    ...nuovaManutenzione,
                    frequency_months: e.target.value,
                  })
                }
                style={inputStyle}
              />
              <div style={helpTextStyle}>
                Inserisci il numero di mesi tra una manutenzione e la successiva.
              </div>
            </div>
          )}

          <div style={fieldWrapperStyle}>
            <div style={labelStyle}>Data prossima manutenzione</div>
            <input
              type="date"
              value={nuovaManutenzione.next_due_date}
              onChange={(e) =>
                setNuovaManutenzione({
                  ...nuovaManutenzione,
                  next_due_date: e.target.value,
                })
              }
              style={inputStyle}
            />
            <div style={helpTextStyle}>
              È la prossima data prevista per eseguire questa manutenzione.
            </div>
          </div>

          <div style={fieldWrapperStyle}>
            <div style={labelStyle}>Note operative</div>
            <textarea
              placeholder="Esempio: Verificare pressione, pulizia filtri e corretto funzionamento."
              value={nuovaManutenzione.notes}
              onChange={(e) =>
                setNuovaManutenzione({
                  ...nuovaManutenzione,
                  notes: e.target.value,
                })
              }
              rows={3}
              style={{ ...inputStyle, resize: "vertical" }}
            />
            <div style={helpTextStyle}>
              Aggiungi eventuali indicazioni utili per il tecnico o per l’ufficio.
            </div>
          </div>

          {renderActions(
            salvaNuovaManutenzione,
            () => setMostraNuovaManutenzione(false),
            "Salva manutenzione"
          )}
        </div>
      )}

      {manutenzioni.length === 0 ? (
        <div style={emptyBoxStyle}>Nessuna manutenzione programmata.</div>
      ) : (
  <div
    style={{
      maxHeight: manutenzioni.length > 2 ? "650px" : "none",
      overflowY: manutenzioni.length > 2 ? "auto" : "visible",
      paddingRight: manutenzioni.length > 2 ? "6px" : 0,
    }}
  >
    {manutenzioni.map((item) => (
          <div
            key={item.id}
            style={{
              ...emptyBoxStyle,
              marginBottom: "12px",
            }}
          >
            <strong>{item.title}</strong>

            <div>
              <strong>Prossima manutenzione:</strong>{" "}
              {formatDate(item.next_due_date)}
            </div>

            <div>
              <strong>Frequenza:</strong>{" "}
              {getFrequenzaLabel(item.frequency_months)}
            </div>

            <div>
              <strong>Stato:</strong> {getStatusBadge(item.status)}
            </div>

            <div>
              <strong>Note:</strong> {item.notes || "—"}
            </div>

            {item.status !== "Completata" ? (
  utenteCorrente?.role !== "viewer" && (
    <div
      style={{
        display: "flex",
        gap: "10px",
        marginTop: "12px",
        flexWrap: "wrap",
      }}
    >
    
      <button
  onClick={() => {
    setManutenzioneInModificaId(item.id);
    setManutenzioneModificata({
      title: item.title || "",
      frequency_months: item.frequency_months || "",
      next_due_date: item.next_due_date || "",
      status: item.status || "Programmato",
      notes: item.notes || "",
    });
  }}
  style={{
    background: "#e0f2fe",
    color: "#075985",
    border: "none",
    borderRadius: "10px",
    padding: "10px 16px",
    cursor: "pointer",
    fontWeight: 700,
    fontSize: "14px",
    transition: "all 0.2s ease",
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.background = "#bae6fd";
    e.currentTarget.style.transform = "translateY(-1px)";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.background = "#e0f2fe";
    e.currentTarget.style.transform = "translateY(0)";
  }}
>
  ✏️ Modifica
</button>

      <button
        onClick={() => handleCompletaManutenzione(item.id)}
        style={{
          background: "#dcfce7",
          color: "#166534",
          border: "none",
          borderRadius: "10px",
          padding: "10px 16px",
          cursor: "pointer",
          fontWeight: 700,
          fontSize: "14px",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "#bbf7d0";
          e.currentTarget.style.transform = "translateY(-1px)";
          e.currentTarget.style.boxShadow =
            "0 4px 10px rgba(22,101,52,0.18)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "#dcfce7";
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "none";
        }}
      >
        ✓ Completa manutenzione
      </button>

      <button
        onClick={() => handleEliminaManutenzione(item.id)}
        style={{
          background: "#dc2626",
          color: "#fff",
          border: "none",
          borderRadius: "10px",
          padding: "10px 16px",
          cursor: "pointer",
          fontWeight: 700,
          fontSize: "14px",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "#b91c1c";
          e.currentTarget.style.transform = "translateY(-1px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "#dc2626";
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        🗑 Elimina
      </button>
    </div>
  )
) : (
  <div
    style={{
      marginTop: "12px",
      background: "#ecfeff",
      color: "#0f766e",
      borderRadius: "8px",
      padding: "8px 12px",
      fontWeight: 700,
      display: "inline-block",
    }}
  >
    ✓ Manutenzione completata
  </div>
)}

{manutenzioneInModificaId === item.id && (
  <div
    style={{
      marginTop: "16px",
      padding: "16px",
      borderRadius: "12px",
      background: "#f8fafc",
      border: "1px solid #dbeafe",
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    }}
  >
    <input
      value={manutenzioneModificata.title}
      onChange={(e) =>
        setManutenzioneModificata({
          ...manutenzioneModificata,
          title: e.target.value,
        })
      }
      placeholder="Titolo manutenzione"
      style={inputStyle}
    />

    <input
      type="date"
      value={manutenzioneModificata.next_due_date}
      onChange={(e) =>
        setManutenzioneModificata({
          ...manutenzioneModificata,
          next_due_date: e.target.value,
        })
      }
      style={inputStyle}
    />

    <select
  value={manutenzioneModificata.status}
  onChange={(e) =>
    setManutenzioneModificata({
      ...manutenzioneModificata,
      status: e.target.value,
    })
  }
  style={inputStyle}
>
  <option value="Programmato">Programmato</option>
  <option value="Completata">Completata</option>
  <option value="Annullata">Annullata</option>
</select>

    <textarea
      value={manutenzioneModificata.notes}
      onChange={(e) =>
        setManutenzioneModificata({
          ...manutenzioneModificata,
          notes: e.target.value,
        })
      }
      rows={3}
      placeholder="Note"
      style={{
        ...inputStyle,
        resize: "vertical",
      }}
    />

    <div
      style={{
        display: "flex",
        gap: "10px",
      }}
    >
      <button
  onClick={() => {
    if (typeof modificaManutenzione !== "function") {
      alert("Funzione modifica manutenzione non disponibile.");
      return;
    }

    modificaManutenzione(
      item.id,
      manutenzioneModificata
    );

    setManutenzioneInModificaId(null);
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = "translateY(-1px)";
    e.currentTarget.style.boxShadow =
      "0 4px 12px rgba(23,58,99,0.25)";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = "none";
  }}
  style={{
    ...primaryButtonStyle,
    transition: "all 0.2s ease",
  }}
>
  Salva modifiche
</button>

      <button
  onClick={() => setManutenzioneInModificaId(null)}
  onMouseEnter={(e) => {
    e.currentTarget.style.background = "#cbd5e1";
    e.currentTarget.style.transform = "translateY(-1px)";
    e.currentTarget.style.boxShadow =
      "0 4px 10px rgba(71,85,105,0.18)";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.background = "#e2e8f0";
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = "none";
  }}
  style={{
    background: "#e2e8f0",
    border: "none",
    borderRadius: "8px",
    padding: "10px 14px",
    cursor: "pointer",
    fontWeight: 600,
    transition: "all 0.2s ease",
  }}
>
  Annulla
</button>
    </div>
  </div>
)}

                    </div>
        ))}
  </div>
)}
    </div>
  );
}

export default MaintenancePanel;